<template>
  <div class="text-xs-center">
    <v-menu bottom left>
      <v-btn slot="activator" icon>
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-list>
        <v-list-tile v-for="(item, i) in items" :key="i" @click="$emit(item.event, item.payload)">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [
        { title: "Click Me", event: "e1", payload: "data" },
        { title: "Click Me Noooow", event: "e2", payload: { a: 1 } }
      ]
    }
  }
};
</script>
